// public/js/html-loader.js
export async function loadHTML(filePath, targetElementId) {
  console.log(`🔄 HTML Loader: Attempting to load ${filePath} into #${targetElementId}`);
  try {
    // Add cache busting to prevent browser caching issues
    const cacheBuster = `?_cb=${Date.now()}`;
    const urlToFetch = `${filePath}${cacheBuster}`;
    
    console.log(`🔄 HTML Loader: Fetching ${urlToFetch}...`);
    const response = await fetch(urlToFetch);
    if (!response.ok) {
      console.error(`❌ HTML Loader: HTTP error ${response.status} ${response.statusText} when fetching ${filePath}`);
      throw new Error(`Failed to load HTML from ${filePath}: ${response.status} ${response.statusText}`);
    }
    
    console.log(`✅ HTML Loader: Successfully fetched ${filePath}, extracting text...`);
    const htmlText = await response.text();
    
    console.log(`🔍 HTML Loader: Looking for target element #${targetElementId}...`);
    const targetElement = document.getElementById(targetElementId);
    
    if (targetElement) {
      console.log(`✅ HTML Loader: Found target element #${targetElementId}, injecting HTML...`);
      targetElement.innerHTML = htmlText;
      console.log(`✅ HTML Loader: Successfully injected HTML into #${targetElementId}`);
      return true; // Indicate success, so we know it's safe to attach listeners
    } else {
      console.error(`❌ HTML Loader: Target element with ID '${targetElementId}' not found.`);
      return false;
    }
  } catch (error) {
    console.error(`❌ HTML Loader Error: ${error}`);
    return false;
  }
}
